export default __webpack_public_path__ + "img/stars.40ddb407.png";